"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalConfig = exports.isBrowser = void 0;
const CoreConfiguration_1 = __importDefault(require("../../config/CoreConfiguration"));
// TODO: After moving to CSR, get rid of isBrowser checking
exports.isBrowser = typeof window !== 'undefined';
const getGlobalConfig = () => {
    var _a, _b, _c;
    if (exports.isBrowser) {
        const config = (_c = (_b = (_a = window.__PRELOADED_STATE__) === null || _a === void 0 ? void 0 : _a.configProvider) === null || _b === void 0 ? void 0 : _b.config) !== null && _c !== void 0 ? _c : CoreConfiguration_1.default.getInstance().appConfig;
        if (config === undefined) {
            throw Error('Couldnt find application config');
        }
        return config;
    }
    return global.config;
};
exports.getGlobalConfig = getGlobalConfig;
//# sourceMappingURL=index.js.map